/**
 * Código propuesto para una tienda nueva: `<CÓDIGO DEL COMERCIO>-<NN>`.
 * NN = (mayor número entre los códigos de las tiendas de ESE comercio que cumplen
 * /^<CÓDIGO>-(\d+)$/i) + 1, con 2 dígitos como mínimo (01, 02 … 10). Sin tiendas con
 * ese patrón: `<CÓDIGO>-01`. Función pura: no consulta nada.
 */
export function codigoTiendaSugerido(codigoComercio: string, codigosTiendas: Array<string | null | undefined> = []): string {
  const base = String(codigoComercio || '').trim().toUpperCase();
  if (!base) return '';
  const escapado = base.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const patron = new RegExp(`^${escapado}-(\\d+)$`, 'i');
  let max = 0;
  for (const c of codigosTiendas || []) {
    const m = patron.exec(String(c || '').trim());
    if (m) max = Math.max(max, parseInt(m[1], 10));
  }
  return `${base}-${String(max + 1).padStart(2, '0')}`;
}

/**
 * La regla del código de tienda (Juan, 2026-10-14), la misma del núcleo (`tienda-inicial.js`):
 * letras, números, guion, punto y guion bajo; sin espacios; hasta 20; empieza por letra o número.
 */
export const CODIGO_TIENDA = /^[A-Z0-9][A-Z0-9._-]{0,19}$/;
export const AYUDA_CODIGO_TIENDA = 'Letras, números, guion, punto o guion bajo; sin espacios. Te proponemos uno; puedes cambiarlo. No se puede repetir.';
/** El código como se guarda: sin espacios y en mayúsculas. */
export function limpiarCodigoTienda(v: string | null | undefined): string {
  return String(v || '').replace(/\s/g, '').toUpperCase();
}
